import { useLocalizedHref } from '@/libraries/web-framework/src/localization/use-localized-href';

import { MicroCtaFields } from '../types.ts';

export function useLocalizedCtaUrl(ctaFields: MicroCtaFields | undefined) {
	return useLocalizedHref(ctaFields?.ctaUrl ?? '');
}
